import { render, staticRenderFns } from "./ProjectHotel.vue?vue&type=template&id=3ea62d9c&"
import script from "./ProjectHotel.vue?vue&type=script&lang=js&"
export * from "./ProjectHotel.vue?vue&type=script&lang=js&"
import style0 from "./ProjectHotel.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports